import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

export default function ProjectComponent() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 120,
      easing: "ease-out-cubic",
    });
  }, []);

  return (
    <section className="relative py-12 lg:py-24 px-6 md:px-16 lg:px-24 overflow-hidden bg-[#F7F4EE]">

      {/* SOFT GLOW */}
      <div className="absolute top-[-200px] left-1/2 -translate-x-1/2 w-[900px] h-[900px] bg-green-200/20 blur-[140px] rounded-full" />

      <div className="relative max-w-7xl mx-auto">

        {/* ================= TOP PLATFORM INTRO ================= */}
        <div className="grid lg:grid-cols-2 gap-12 items-center">

          {/* LEFT TEXT */}
          <div data-aos="fade-right">

            <p className="text-xs tracking-[0.4em] text-green-500 uppercase">
              Project Platform
            </p>

            <div>
              <h2
                data-aos="fade-up"
                data-aos-delay="100"
                className="mt-6 text-3xl md:text-6xl font-semibold text-[#1E1B16] leading-tight"
              >
                Climate Community Initiatives
              </h2>

              <p
                data-aos="fade-up"
                data-aos-delay="200"
                className="mt-6 text-[#5C5548] text-md lg:text-lg max-w-2xl leading-relaxed"
              >
                Scalable, community-driven climate programs empowering women,
                youth, farmers, and local communities through climate-smart
                agriculture, environmental education, conservation practices,
                renewable energy awareness, and sustainable livelihood
                solutions.
              </p>
            </div>

            {/* SYSTEM TAGS */}
            <div
              data-aos="fade-up"
              data-aos-delay="300"
              className="mt-8 flex flex-wrap gap-3"
            >
              {[
                "Climate-Smart Agriculture",
                "Sustainability",
                "Empowerment",
                "Conservation",
                "Resilience",
                "Livelihoods",
              ].map((item, i) => (
                <div
                  key={i}
                  className="px-4 py-2 text-sm rounded-full bg-white border border-green-100 text-[#3E3A33] hover:border-green-400 transition-all duration-300"
                >
                  {item}
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT VISUAL */}
          <div
            data-aos="fade-left"
            className="relative h-[400px] md:h-[500px] rounded-[32px] overflow-hidden shadow-2xl"
          >
            <img
              alt="Project Design Catalog"
              src="https://images.unsplash.com/photo-1509099836639-18ba1795216d?auto=format&fit=crop&w=1600&q=80"
              className="w-full h-full object-cover"
            />

            <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/80 via-black/20 to-transparent" />

            {/* subtle border */}
            <div className="absolute inset-0 ring-1 ring-green-400/20 rounded-[32px]" />

            <div
              data-aos="fade-up"
              data-aos-delay="200"
              className="absolute bottom-6 left-6 text-white max-w-sm"
            >
              <p className="text-xs tracking-widest text-green-400 uppercase">
                SYSTEM DESIGN
              </p>

              <p className="text-lg md:text-xl font-semibold mt-2 leading-snug">
                Modular. Replicable. Locally Adaptable.
              </p>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
}